import {
  Card,
  Chip,
  IconButton,
  Modal,
  Stack,
  Typography,
  Grid as Grid,
  Box,
  useTheme,
  useMediaQuery,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { BIBlue } from "../../assets/helpers";
import { ArrowUpward } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
const JobpostingTutorial = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.JobPostings || {};
  const {
    TEXT_JOB_POSTING_HEADER = English.JobPostings.TEXT_JOB_POSTING_HEADER,
    TEXT_QUICKLY_FIND = English.JobPostings.TEXT_QUICKLY_FIND,
    TEXT_ONCE_CREATED = English.JobPostings.TEXT_ONCE_CREATED,
    TEXT_TAP_ANYWHERE = English.JobPostings.TEXT_TAP_ANYWHERE,
    TEXT_AFTER_ENTERING = English.JobPostings.TEXT_AFTER_ENTERING,
    TEXT_SELECT_THE_JOB_THAT = English.JobPostings.TEXT_SELECT_THE_JOB_THAT,
    TEXT_RESUME_YOU_MAKE_ON = English.JobPostings.TEXT_RESUME_YOU_MAKE_ON,
    KM_AWAY = English.JobPostings.KM_AWAY
  } = LanguageData || {};

  const activeJobs = [
    {
      id: 8,
      siteId: 9913,
      siteName: "fghfh",
      address: "",
      city: "",
      province: "",
      postalCode: "",
      country: "",
      latitude: 0,
      longitude: 0,
      projectId: 2845,
      projectName: "Abc Project",
      tradeId: 9,
      tradeName: "Electrician",
      companyId: 1573,
      companyName: "The Haebler Group",
      jobDuration: 1,
      jobDurationType: "Year(s)",
      email: "tejashree.bhuse@stepron.com",
      jobPostExpiryDate: "2025-06-06T11:37:51.177",
      isExpired: false,
      description: "gdh",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 9,
      dateCreated: "2025-05-23T11:37:51.177",
      modifiedBy: 9,
      dateModified: "2025-05-23T11:37:51.177",
      createdByUser: "Ram",
      modifiedByUser: "Ram",
      distance: 1.7,
      isApplied: false
    }
  ];
  const renderJobList = (itemList) => {
    return itemList.map((item, index) => (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{
          marginTop: "0px",
          padding: 0,
          cursor: "pointer",
          backgroundColor: item?.isApplied ? "#f0f0f0" : "white"
        }}>
        <ListItem
          alignItems="flex-start"
          sx={{ m: 0, p: 0 }}
          key={index.toString()}
          secondaryAction={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          }>
          <ListItemButton alignItems="flex-start" sx={{ m: 0 }}>
            <ListItemText sx={{ mt: 0, alignItems: "flex-start", alignItems: "center" }} primary={ <Stack spacing={1} direction={"row"}>
                  <Typography variant="body1" maxWidth={"430px"} noWrap>
                    {item?.projectName}
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }} variant="body1" maxWidth={"430px"} noWrap>
                    ({item?.distance} {KM_AWAY})
                  </Typography>
                </Stack>
              }
              secondary={
                <Box>
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {item?.companyName}
                  </Typography>
                  <Stack sx={{ pt: 0.5, alignItems: "center" }} spacing={1} direction={"row"}>
                    <Chip label={item?.tradeName} />
                    {item?.jobDuration && item?.jobDurationType && (
                      <Chip
                        label={item?.jobDuration + " " + item?.jobDurationType.replace("(s)", "")}
                      />
                    )}
                  </Stack>
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box
            className="main-content-Box"
            sx={{ p: isSmallScreen ? 2 : 3, pt: 2, backgroundColor: "transparent" }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_JOB_POSTING_HEADER}</Typography>
                  <Typography variant="subtitle1">{TEXT_QUICKLY_FIND}</Typography>
                  <Typography variant="subtitle1"> {TEXT_ONCE_CREATED} </Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}> {TEXT_TAP_ANYWHERE}</span>
                  </Typography>
                </Stack>
              </Box>
            )}
            {props.tutorialIndex === 2 && (
              <Card
                className="main-content-card"
                sx={{ backgroundColor: "transparent !important", border: "none" }}>
                <Box className="main-content-card-list" sx={{ mt: { xs: 9, sm: 9, md: 10 } }}>
                  <List disablePadding>
                    <Stack sx={{ gap: 1 }} >{renderJobList(activeJobs)}</Stack>
                  </List>
                  <Stack sx={{ display: "flex", alignItems: "center", pt: 2 }}>
                    <Stack
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "white"
                      }}>
                      <ArrowUpward />
                      <Typography variant="subtitle1" style={{ color: "white" }}>
                        {TEXT_AFTER_ENTERING}
                      </Typography>
                      <Typography variant="subtitle1" style={{ color: "white" }}>
                        {TEXT_SELECT_THE_JOB_THAT}
                      </Typography>
                      <Typography variant="subtitle1" style={{ color: "white" }}>
                        {TEXT_RESUME_YOU_MAKE_ON}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Card>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default JobpostingTutorial;

